export default __webpack_public_path__ + "static/media/suspension.0d93c02b.png";